import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';

export default {
    name: 'TripCategories',
    mixins: [HelperMixin],

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.requireUserType([1])) return;
        this.GetInfo();
    },

    computed: {
        activeCount() {
            return (this.Info || []).filter(x => x.status == 1).length;
        },
        notActiveCount() {
            return (this.Info || []).filter(x => x.status == 2).length;
        }
    },

    data() {
        return {
            ScreenTitle: ' فئات الرحلات والتسعير ',
            ScreenTitleSingle: ' فئة رحلة ',
            ScreenTitleSingleAl: 'فئة الرحلة ',
            Info: [],
            SelectedItem: '',
            // TripType matches the backend TripsCategory.TripType (see TripsController).
            TripTypeOptions: [
                { value: 1, label: 'عادية' },
                { value: 2, label: 'مشتركة' },
                { value: 3, label: 'مدرسية' },
                { value: 5, label: 'نسائية' }
            ],
            // RequiredVehicleTier mirrors DriversVehicle.Tier eligibility.
            VehicleTierOptions: [
                { value: 0, label: 'بدون قيد' },
                { value: 1, label: 'عادي' },
                { value: 2, label: 'فاخر' }
            ],
            ruleForm: {
                Id: '',
                Name: '',
                Descriptions: '',
                Icon: '',
                TripType: null,
                RequiredVehicleTier: null,
                BaseFare: 0,
                PerKm: 0,
                PerMinuteInTrip: 0
            },
            rules: { Name: this.$helper.Required() }
        };
    },

    methods: {
        GetInfo() {
            this.$blockUI.Start();
            this.$http.GetTripCategories()
                .then(response => {
                    this.$blockUI.Stop();
                    this.Info = (response.data && response.data.info) || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                });
        },

        BuildBody() {
            return {
                Id: Number(this.ruleForm.Id) || 0,
                Name: this.ruleForm.Name,
                Descriptions: this.ruleForm.Descriptions,
                Icon: this.ruleForm.Icon,
                TripType: this.ruleForm.TripType !== null && this.ruleForm.TripType !== '' ? Number(this.ruleForm.TripType) : null,
                RequiredVehicleTier: this.ruleForm.RequiredVehicleTier !== null && this.ruleForm.RequiredVehicleTier !== '' ? Number(this.ruleForm.RequiredVehicleTier) : null,
                BaseFare: Number(this.ruleForm.BaseFare) || 0,
                PerKm: Number(this.ruleForm.PerKm) || 0,
                PerMinuteInTrip: Number(this.ruleForm.PerMinuteInTrip) || 0
            };
        },

        submitForm(formName) {
            const form = this.$refs[formName];
            if (!form) return;
            form.validate((valid) => {
                if (!valid) { this.$helper.showSwal('warning'); return; }
                this.$blockUI.Start();
                this.$http.AddTripCategories(this.BuildBody())
                    .then(response => {
                        this.$blockUI.Stop();
                        this.GetInfo();
                        this.ClearForm(this.ruleForm);
                        this.$helper.DestroyElemntById('CloseAdd');
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response && err.response.data ? err.response.data : 'حدث خطأ');
                    });
            });
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Descriptions = item.descriptions || '';
            this.ruleForm.Icon = item.icon || '';
            this.ruleForm.TripType = item.tripType !== undefined && item.tripType !== null ? item.tripType : null;
            this.ruleForm.RequiredVehicleTier = item.requiredVehicleTier !== undefined && item.requiredVehicleTier !== null ? item.requiredVehicleTier : null;
            // PricingConfig (baseFare/perKm/perMinuteInTrip) is the billing source of truth;
            // fall back to the legacy category fields when no config row exists yet.
            this.ruleForm.BaseFare = item.baseFare != null ? item.baseFare : (item.basePrice != null ? item.basePrice : 0);
            this.ruleForm.PerKm = item.perKm != null ? item.perKm : (item.pricePerKm != null ? item.pricePerKm : 0);
            this.ruleForm.PerMinuteInTrip = item.perMinuteInTrip != null ? item.perMinuteInTrip : 0;
        },

        submitEditForm(formName) {
            const form = this.$refs[formName];
            if (!form) return;
            form.validate((valid) => {
                if (!valid) { this.$helper.showSwal('warning'); return; }
                this.$blockUI.Start();
                this.$http.EditTripCategories(this.BuildBody())
                    .then(response => {
                        this.$blockUI.Stop();
                        this.GetInfo();
                        this.ClearForm(this.ruleForm);
                        this.$helper.DestroyElemntById('CloseEdit');
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response && err.response.data ? err.response.data : 'حدث خطأ');
                    });
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من تغيير حالة الفئة؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusTripCategories(Id)
                        .then(() => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم تغيير الحالة بنجاح');
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ');
                        });
                }
            });
        },

        TripTypeLabel(value) {
            const found = this.TripTypeOptions.find(o => o.value == value);
            return found ? found.label : '—';
        },

        VehicleTierLabel(value) {
            if (value === undefined || value === null) return '—';
            const found = this.VehicleTierOptions.find(o => o.value == value);
            return found ? found.label : '—';
        }
    }
};
